.field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.label {
  color: var(--cl-text);
  font-size: var(--cl-fs-base);
}

.required {
  color: var(--cl-danger);
}

/* cl-form-control: 40px, 1px #C6D2D9, 2px radius, focus border #9BA8B0 with no ring. */
.control {
  display: flex;
  align-items: center;
  min-width: 0;
  height: var(--cl-control-height);
  border: 1px solid var(--cl-border);
  border-radius: var(--cl-radius);
  background: var(--cl-input-bg);
  color: var(--cl-input-text);
  transition: none;
}

.control:focus-within {
  border-color: var(--cl-border-focus);
}

.sm {
  height: var(--cl-control-height-sm);
  font-size: var(--cl-fs-xs);
}

.auth {
  border-color: var(--cl-auth-control-border);
  border-radius: var(--cl-radius-auth);
  background: var(--cl-auth-control-bg);
  color: var(--cl-auth-control-text);
}

.auth.invalid {
  border-color: var(--cl-auth-control-error);
}

.invalid {
  border-color: var(--cl-danger);
}

.disabled {
  background: var(--cl-input-bg-disabled);
}

.input {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 8.5px 10.5px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: inherit;
  outline: none;
}

.auth .input {
  padding: 8px 13px;
}

.sm .input {
  padding: 2px 8px;
}

.input::placeholder {
  color: var(--cl-text-placeholder);
}

.affix {
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  color: var(--cl-text-muted);
}

.affix + .input {
  padding-left: 0;
}

.hint {
  color: var(--cl-text-muted);
  font-size: var(--cl-fs-xs);
}

.error {
  color: var(--cl-danger);
  font-size: var(--cl-fs-xs);
}
